<!-- <mat-chip-list aria-label="Fish selection">
<mat-chip *ngFor="let chip of chips; let i = index">
  <app-zone-identifiers-detail [chip]="chip" [lastInList]="chips.length == i+1"></app-zone-identifiers-detail>
</mat-chip>
</mat-chip-list> -->

@if (totalZoneCountForStrain != 0) {
  <div style="float: left; margin-right: 20px">
    <span style="font-weight: bold; color: #43a047;">[{{totalZoneCountForStrain}}]</span>
  </div>
}
<ul>
  @for (zone of zoneIdentifiers; track zone) {
    <li>
      {{zone.name}} @if (zone.placements != null) {
      <span style="font-size: 14px; color: #43a047">({{zone.placements}})</span>
    }
    @if (zone.zones != null && zone.zones.length > 0) {
      <app-zone-identifiers-detail [zones]="zone.zones"></app-zone-identifiers-detail>
    }
  </li>
}
</ul>
